export default __webpack_public_path__ + "bg_anli_zhengwu01b693db.png";